import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background split layout */}
      <div className="absolute inset-0 flex">
        <div className="w-full sm:w-2/5 bg-white"></div>
        <div className="hidden sm:block sm:w-3/5 relative">
          <img
            src="https://public.readdy.ai/ai/img_res/d88ee8af405f54fef6e8c9c21cb59d6d.jpg"
            alt="Professional Business Meeting"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-[#255485]/20"></div>
        </div>
      </div>

      {/* Mobile background image */}
      <div className="absolute inset-0 sm:hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20business%20team%20meeting%20in%20modern%20office%20with%20diverse%20executives%20discussing%20strategy%20around%20conference%20table%2C%20natural%20lighting%2C%20corporate%20atmosphere%2C%20high%20quality%20photography%2C%20clean%20and%20sophisticated%20environment%20with%20warm%20tones%20and%20elegant%20interior%20design&width=1200&height=900&seq=hero-business-meeting-001&orientation=landscape"
          alt="Professional Business Meeting"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-white/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full">
        <div className="flex items-center">
          <div className="w-full sm:w-2/5 sm:pr-12 py-12 sm:py-0">
            <p className="text-[#255485] text-xs sm:text-sm font-medium tracking-wider mb-4 sm:mb-6">
              {t('hero.eyebrow')}
            </p>
            <h1 className="text-3xl sm:text-4xl font-serif leading-relaxed text-gray-900 mb-6 sm:mb-8">
              {t('hero.title.line1')}<br />
              <span className="text-[#255485] font-bold">{t('hero.title.highlight1')}</span>{t('hero.title.and')}<br />
              <span className="text-[#255485] font-bold">{t('hero.title.highlight2')}</span><br />
              {t('hero.title.line2') && <>{t('hero.title.line2')}<br /></>}
              {t('hero.title.line3')}<br />
              {t('hero.title.line4')}
            </h1>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <button
                onClick={() => scrollToSection('services')}
                className="bg-[#255485] text-white px-6 sm:px-8 py-3 sm:py-3.5 rounded-lg hover:bg-[#1d4166] transition-colors duration-200 font-medium whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                {t('hero.cta.services')}
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-white text-[#255485] px-6 sm:px-8 py-3 sm:py-3.5 rounded-lg border-2 border-[#255485] hover:bg-[#255485] hover:text-white transition-colors duration-200 font-medium whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                {t('hero.cta.contact')}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden sm:block">
        <div className="w-6 h-10 border-2 border-[#255485]/40 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-[#255485]/40 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
